import React, { type JSX } from 'react'
import classNames from 'classnames'
import SvgArrowUp from '../../svg/arrow-up.svg'
import { IconProps } from '../icon-props'

const ArrowUpIcon = ({
  className = '',
  multiLayered = false,
  ...props
}: IconProps): JSX.Element | null => (
  <SvgArrowUp
    {...props}
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    className={classNames('i-arrowup', className, {
      'i-multi-layered': multiLayered,
    })}
  />
)

export default ArrowUpIcon
